<!-- eslint-disable -->
<template>
  <el-row class="app-header" type="flex">
    <h1 class="app-header__title">{{ title }}</h1>

    <el-row type="flex" class="r-panel">
      <!-- <TranslateSwitcher /> -->
      <div>
        <el-button type="danger" @click="goToSupport">
          {{$t('constants.get_support')}}
        </el-button>
      </div>

      <div class="content-center">
        <p>{{ $t('theme.current') }} {{ theme }}</p>

        <el-button
          size="small"
          type="success"
          class="margin-20-left"
          @click="toggleTheme"
        >
          {{ $t('theme.switch')}}
        </el-button>
      </div>

      <el-select
        v-model="activePark"
        :placeholder="getActualPark().name"
        @change="fetchSwitchPark(activePark)"
        filterable
      >
        <el-option
          v-for="val in getUserParks()"
          :key="val.id"
          :label="val.name"
          :value="val.id">
        </el-option>
      </el-select>
      <img class="app-header__icon" src="@/assets/svg/bell.svg"
           alt="Icon Rik SIde Menu"/>
      <el-dropdown>
        <el-avatar icon="el-icon-user-solid"></el-avatar>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>{{ this.$_userEmail }}</el-dropdown-item>
          <el-dropdown-item @click.native="handleLogoutUser">
            {{ $t('constants.exit') }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-row>

  </el-row>
</template>

<!-- eslint-disable -->
<script>
import user from '@/mixin/user'
import settings from '@/mixin/settings'
import { mapActions, mapGetters } from 'vuex'
import {
  auto as followSystemColorScheme,
  disable as disableDarkMode,
  enable as enableDarkMode,
  isEnabled as isDarkReaderEnabled
} from 'darkreader'
// import TranslateSwitcher from '@/core/components/TranslateSwitcher.vue'
import { i18n } from '@/i18n'

export default {
  name: 'appHeader',
  // components: { TranslateSwitcher },
  props: {
    title: String,
    avatar: String
  },
  computed: {
    ...mapGetters('userStore', ['getActualPark', 'getUserParks']),
    // ...mapGetters('user', {
    //   getActualPark: 'getActualPark',
    //   getUserParks: 'getUserParks'
    // })
  },
  data () {
    return {
      activePark: null,
      theme: ''
    }
  },
  mixins: [
    user,
    settings
  ],
  methods: {
    ...mapActions('userStore', ['logoutUser', 'fetchSwitchPark']),
    // ...mapActions('user', {
    //   switchPark: 'switchPark'
    // }),
    goToSupport () {
      this.$router.push('/notify/appeal')
    },
    handleLogoutUser () {
      this.logoutUser()
    },
    toggleTheme () {
      const isEnabled = isDarkReaderEnabled()

      if (isEnabled) {
        this.theme = i18n.t('theme.light')

        disableDarkMode()

        return
      }

      if (!isEnabled) {
        this.theme = i18n.t('theme.dark')

        enableDarkMode({
          mode: 1
        })
        followSystemColorScheme()

      }
    },
    logout () {
      this.$_logout()
    }
  },
  mounted () {
    this.theme = i18n.t('theme.light')
  }
}
</script>

<style lang="scss">
.el-avatar {
  cursor: pointer;
}

.r-panel {
  justify-content: end;
  gap: 27px;
  align-items: center;
}

.app-header {
  width: 100%;

  &__title {
    flex: 1;
    min-width: 345px;
    margin: 10px 0;
  }

  &__icon {
    width: 30px;
    height: 30px;
  }
}
</style>
